// extracted by css-extract-rspack-plugin
export default {"v2":"ContentfulPricingOptionsV2-module__v2__IxynM","featuredItem":"ContentfulPricingOptionsV2-module__featuredItem__v_h7O"};